import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            value: props.avatar,
            error: false,
        };
    }

    render() {
        return (
            <profile-picture>
                <row className='is-wrap'>
                    <column className='is-2 is-12-mobile has-text-center-mobile'>
                        <img className='lazyload' data-src={this.state.value} alt='' />
                    </column>
                    <column
                        className={
                            'is-10 is-12-mobile has-text-center-mobile ' +
                            'has-padding-50-top-desktop has-padding-30-left-desktop ' +
                            'has-padding-50-top-tablet has-padding-30-left-tablet'
                        }
                    >
                        <a>
                            <span>Upload New Image</span>
                            <span className='progress'>Uploading...</span>
                            <form id='form-profile-image' onSubmit={this.handleChange}>
                                <input type='file' name='profile_picture_url' onChange={this.handleChange} />
                            </form>
                        </a>
                        {this.renderError()}
                    </column>
                </row>
            </profile-picture>
        );
    }

    renderError = () => {
        if (this.state.error || this.props.error) {
            return (<p className='is-error'>{this.state.error || this.props.error}</p>);
        }

        return null;
    }

    handleChange = () => {
        const form = document.getElementById('form-profile-image');
        const progress = document.querySelector('span.progress');
        const formData = new FormData(form);
        const xhr = new XMLHttpRequest();

        progress.style.width = 0;

        xhr.open('POST', '/api/user/uploadprofilepic', true);

        xhr.onload = () => {
            if (xhr.readyState === 4) {
                let state = null;
                let response = null;
                progress.style.width = 0;

                if (xhr.status === 200) {
                    response = JSON.parse(xhr.response);
                    const url = response.url.replace(/http:\/\//, 'https://s3.amazonaws.com/', response.url);

                    state = {
                        value: url,
                        error: false,
                    };
                } else if (xhr.status == 400) {
                    response = JSON.parse(xhr.response);
                    state = {
                        value: null,
                        error: response.error,
                    };
                } else if (xhr.status == 413) {
                    state = {
                        value: null,
                        error: 'Maximum file size is 100KB',
                    };
                } else {
                    state = {
                        value: null,
                        error: xhr.statusText,
                    };
                }

                this.setState(state);
                this.props.onChange('profile_picture_url', state.value, state.error);
            }
        };

        xhr.upload.addEventListener('progress', event => {
            if (event.lengthComputable) {
                const progress = document.querySelector('span.progress');
                const percent = parseInt(((event.loaded / event.total) * 100), 10);
                progress.style.width = `${percent}%`;
            }
        }, false);

        xhr.send(formData);
    }
}

const mapStateToProps = (state) => ({
    avatar: state.user && state.user.avatar_url,
});

export default connect(mapStateToProps)(Component);
